import Vue from 'vue'
import VueI18n from 'vue-i18n'
import FlagIcon from 'vue-flag-icon'
import axios from 'axios'

Vue.use(VueI18n)
Vue.use(FlagIcon)

const messages = {
  'en': {},
  'ru': {}
}

export const i18n = new VueI18n({
  locale: 'en', // set locale
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
});

// const loadedLanguages = ['en'] // our default language that is preloaded
//
// function setI18nLanguage (lang) {
//   i18n.locale = lang
//   axios.defaults.headers.common['Accept-Language'] = lang
//   document.querySelector('html').setAttribute('lang', lang)
//   return lang
// }

// export function loadLanguageAsync (lang) {
//   if (i18n.locale !== lang) {
//     if (!loadedLanguages.includes(lang)) {
//       return import(axios
//         .get(`/api/v1/translations/lang/${lang}`)).then(msgs => {
//         i18n.setLocaleMessage(lang, msgs.default)
//         loadedLanguages.push(lang)
//         return setI18nLanguage(lang)
//       })
//     }
//     return Promise.resolve(setI18nLanguage(lang))
//   }
//   return Promise.resolve(lang)
// }
